import styled from 'styled-components';

import { StarOutlineIc } from '@dsch/dd-icons';

import { StickyFooter } from 'components/ToolkitV2/StickyFooter/StickyFooter';
import { Button } from 'components/Toolkit/Button/Button';
import { Tooltip } from 'components/ToolkitV2/Tooltip/Tooltip';

import { media } from 'helpers/breakpoints';

const StyledStickyFooter = styled(StickyFooter)`
  display: flex;
  justify-content: center;
  position: fixed;

  padding: ${({ theme }) =>
    `${theme.spacing.S8} ${theme.spacing.S8} ${theme.spacing.M24}`};

  ${media.medium} {
    padding: ${({ theme }) =>
      `${theme.spacing.S8} ${theme.spacing.M16} ${theme.spacing.M24}`};
  }

  ${media.large} {
    display: none;
  }
`;

const StickyFooterSavedSearchButton = styled(Button)`
  width: 146px;
  pointer-events: auto;
`;

const Container = styled.div<{
  active?: boolean;
}>`
  transform: ${({ active }) => (active ? 'translateY(0)' : 'translateY(72px)')};
  transition: transform 0.25s ease-in-out;

  display: flex;
  justify-content: center;
`;

const SavedSearchTooltip = styled(Tooltip)`
  width: ${({ theme }) => `calc(100vw - ${theme.spacing.M16})`};
  display: flex;
  justify-content: center;
`;

const SaveIcon = styled(StarOutlineIc)`
  color: ${({ theme }) => theme.colors.WHITE};
`;

export {
  StyledStickyFooter,
  StickyFooterSavedSearchButton,
  SavedSearchTooltip,
  SaveIcon,
  Container,
};
